export enum FormItemType {
  CustomField = 'customField',
  FormContent = 'formContent',
}

export enum FormItemStatus {
  Active = 'active',
  Archived = 'archived',
}
